<template>
  <div class="party">
    <div class="banner"></div>
    <div class="partycontent">
      <div class="maincontent">
        <div class="partytitle" style="padding-left: 1.25vw">党的建设</div>
        <div class="partyall">
          <div
            class="partysingle"
            v-for="(i, j) in partylist"
            :key="j"
            @mouseenter="partyshover(j)"
            @mouseleave="partyshover(-1)"
            @click="checkinfo(i, j)"
            :style="{
              'margin-top': hoverindex == j ? '-0.52vw' : '0',
              'margin-bottom': hoverindex == j ? '1.56vw' : '1.04vw',
            }"
          >
            <img class="partyicon" :src="i.firstUrl" alt="" />
            <div class="partycon">
              <div class="partytitle" style="background: none">
                {{ i.title }}
              </div>
              <div class="partycontent">{{ i.summary }}</div>
            </div>
            <div class="partytime">
              <div class="mouth">{{ i.createTime.slice(5) }}</div>
              <div class="year">{{ i.createTime.slice(0, 4) }}</div>
              <div
                class="checkmore"
                @click="checkinfo(i, j)"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                查看全部
              </div>
            </div>
          </div>
          <div class="pagination">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="pagesize.total"
              :page-size="pagesize.size"
              @current-change="getlist"
              :current-page.sync="pagesize.page"
              prev-text="上一页"
              next-text="下一页"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      partylist: [],
      hoverindex: -1,
      sendnews: {},
      pagesize: { page: 1, size: 10, total: 0 },
    };
  },
  methods: {
    checkinfo(e) {
      let data = {
        category: "党的建设",
        id: e.id,
        current: 1,
        size: 999,
      };
      this.$router.push({
        path: "/news/info",
        query: data,
      });
    },
    async getlist() {
      try {
        let data = {
          category: "党的建设",
          current: this.pagesize.page,
          size: this.pagesize.size,
        };
        const res = await this.$http.newslist(data);
        if (res.code == 200) {
          this.partylist = res.data; // 更新 partylist
        } else {
          // 处理错误情况
          console.log("Error fetching build list:", res.message);
        }
      } catch (error) {
        console.error("An error occurred while fetching the list:", error);
      }
    },
    checkinfo(e) {
      let data = {
        category: "党的建设",
        id: e.id,
        current: 1,
        size: 999,
      };
      this.$router.push({
        path: "/news/info",
        query: data,
      });
    },
    partyshover(e) {
      // for(){}
      this.hoverindex = e;
    },

    formattime() {
      for (let i in this.partylist) {
        this.partylist[i].year = this.partylist[i].time.slice(0, 4);
        this.partylist[i].mouth = this.partylist[i].time.slice(5, 10);
      }
    },
  },
  beforeMount() {
    this.formattime();
  },
  mounted() {
    this.getlist();
  },
};
</script>

<style scoped lang="less">
.party {
  .partycontent {
    .maincontent {
      .partytitle {
        width: 100%;
        height: 3.6458vw;
        background: rgba(209, 223, 238, 0.7);
        display: flex;
        left: 14.7917vw;
        top: 34.401vw;
        opacity: 1;
        font-family: "Alibaba PuHuiTi 2.0";
        font-size: 28px;
        font-weight: 600;
        line-height: normal;
        display: flex;
        align-items: center;
        letter-spacing: 0em;
        font-feature-settings: "kern" on;
        color: #06192d;
        /* padding-left: 1.5%; */
      }

      .partyall {
        .pagination {
          /* .btn */
          width: 100%;
          height: 2.08vw;
          text-align: center;
          margin-top: 2.6vw;
        }

        .partysingle {
          .checkmore {
            width: 5.21vw;
            height: 2.08vw;
            display: flex !important;
            justify-content: center !important;
            align-items: center !important;
            border: 1px solid white;
            color: white;
            font-size: 0.94vw;
            cursor: pointer;
            background: rgba(22, 104, 188, 1);
            border-radius: 4px;
          }

          .partytime {
            .year {
              font-size: 0.94vw;
              color: rgba(18, 20, 58, 0.65);
            }

            .mouth {
              font-size: 1.46vw;
              color: rgba(18, 20, 58, 0.8);
              font-weight: 550;
            }

            width: 9.3229vw;
            height: 100%;
            border-left: 1px solid rgba(238, 241, 245, 1);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 0.94vw;
          }

          .partycon {
            .partycontent {
              width: 100%;
              height: 5vw;
              font-size: 0.83vw;
              line-height: 1.67vw;
              color: rgba(18, 20, 58, 0.65);
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              /* 显示的最大行数 */
              overflow: hidden;
            }

            .partytitle {
              font-size: 1.25vw;
              width: 100%;
              height: 1.61vw;
              margin-bottom: 1.25vw;
              font-weight: 600;
              color: rgba(6, 25, 45, 1);
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
            }

            width: 44.6875vw;
            height: 7.92vw;
            padding-right: 2.08vw;
          }

          .partyicon {
            width: 11.98vw;
            height: 7.92vw;
            margin-right: 1.25vw;
          }

          width: 100%;
          height: 10.42vw;
          /* box-shadow: 0px 3px 15px 0px rgba(68, 86, 103, 0.15); */
          padding: 1.25vw;
          display: flex;
          position: relative;
          padding-right: 0;
          margin-bottom: 0.04vw;
          border-bottom: 1px solid rgba(6, 25, 45, 0.2);
        }

        padding: 0.5208vw 1.5625vw 6.7708vw 1.5625vw;
        width: 100%;
        background: #fff;
      }

      flex: 1;
      padding: 2.0833vw 13.5417vw 5.2083vw 13.5417vw;
    }

    width: 100%;
    height: 76.25vw;
    /* padding: 3.13vw 13.54vw; */
    display: flex;
  }

  .banner {
    width: 100%;
    height: 26.0417vw;
    //background: url("https://crec-website-1321777854.cos.ap-chengdu.myqcloud.com/news-picture/2024-01-30/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20240130173506-1706607341653.jpg?q-sign-algorithm=sha1&q-ak=AKIDvvoX3LQjx6GSWO2jFZlmaCdqqeM0Tjmm&q-sign-time=1706607342%3B3283407342&q-key-time=1706607342%3B3283407342&q-header-list=host&q-url-param-list=&q-signature=ec4cd8decd4ce11831a9b0c9c793ab384a9245dc")
    background: url("https://ygs-official-website-prod.oss-cn-shanghai.aliyuncs.com/web-pic-bed/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20240130173506-1706607341653.jpg")
      no-repeat;
    background-position: 0 0;
    background-size: 100% ;
  }

  width: 100%;
  background: rgba(240, 242, 246, 1);
}
</style>
